import { dynamicStylingHelper } from '@oneaudi/vtp-shared';
import styled from 'styled-components';

export const FiltersAndTilesWrapper = styled.div`
  display: flex;
  align-items: ${dynamicStylingHelper('baseline', 'flex-start')};
  width: 100%;
`;
